import {Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter} from '@angular/core';
import {SharedConstant} from '../../constants/sharedConstants';
import {ConfirmationService} from 'primeng/api';
import {ConfirmMessage, DefaultConfirmMessage} from '../../models/confirm-message.model';
import {SharedService} from '../../shared.service';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'ems-confirm-message',
  templateUrl: './confirm-message.component.html'
})
export class ConfirmMessageComponent implements OnInit, AfterViewInit {

  deactivateClientForm: UntypedFormGroup;

  @ViewChild('inputEl', {static: false}) inputEl: ElementRef;
  @ViewChild('cd') cd: ConfirmDialog;
  acceptButton: any = SharedConstant.confirmationDialog.acceptBtn;
  rejectButton: any = SharedConstant.confirmationDialog.rejectBtn;
  confirmMessage: ConfirmMessage = DefaultConfirmMessage;
  shouldHideAcceptButton: boolean;
  shouldHideRejectButton: boolean;
  closeIconButton = true;
  cancelBtnRejectGutTack = '';
  sharedConstant = SharedConstant;
  showCharLimit: boolean;
  message = '';
  @Input() businessJustification: boolean;
  @Output() deactivationReason = new EventEmitter();
  showDoNotShowAgain = false;
  doNotShowAgain: boolean;
  proceedButton: any;
  disableRejectBtn = false;

  constructor(public fb: UntypedFormBuilder, public confirmationService: ConfirmationService, public sharedService: SharedService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.deactivateClientForm = this.fb.group({
      businessJustificationValue: ['', Validators.required]
    });
  }
  
  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  showConfirmMsg(confirmObj, observer) {
    this.shouldHideAcceptButton = confirmObj.acceptBtn !== SharedConstant.confirmationDialog.hideAcceptButton;
    this.shouldHideRejectButton = confirmObj.rejectBtn !== SharedConstant.confirmationDialog.hideRejectButton;
    this.cd.acceptLabel = confirmObj.acceptBtn || this.sharedConstant.confirmationDialog.acceptBtn;
    this.cd.rejectLabel = confirmObj.rejectBtn || this.sharedConstant.confirmationDialog.rejectBtn;
    this.closeIconButton = confirmObj.hasOwnProperty('closeIconButton') ? confirmObj.closeIconButton : true;
    this.message = confirmObj.message;
    this.showDoNotShowAgain = confirmObj.showDoNotShowAgain || false;
    this.disableRejectBtn = !!confirmObj.disableRejectBtn;
    
    this.cd.acceptVisible = false;
    this.proceedButton = confirmObj.showInput;
    /* Showing ConfirmationDialog Box while clicking Cancel/Away after edit */
    this.confirmationService.confirm({
      key: 'confirmBox',
      header: confirmObj.header,
      message: confirmObj.message,
      acceptVisible: this.shouldHideAcceptButton,
      rejectVisible: this.shouldHideRejectButton,
      accept: () => {
        if (this.showDoNotShowAgain) {
          observer.next({ accepted: true, dontshow: this.doNotShowAgain });
        } else {
          observer.next(true);
        }
        observer.complete();
        confirmObj.message = '';
        this.sharedService.isLoadPage = false;
        this.deactivationReason.emit(this.deactivateClientForm.get('businessJustificationValue').value);
      },
      reject: () => {
        observer.next(false);
        observer.complete();
        confirmObj.message = '';
        this.deactivateClientForm.get('businessJustificationValue').reset();
        if (this.sharedService.isLoadPage) {
          this.sharedService.isLoadPage = false;
          /* Set isDTBtnClicked value to true, generate the data track value with 'linkid-lc' . */
          this.sharedService.isDTBtnClicked = true;
          this.sharedService.loadDataTrackValue(this.cancelBtnRejectGutTack);
          this.sharedService.isDTValueUpdated = false;
          this.sharedService.loadSpsPageCall();
        }
      }
    });
  }
  verifyDisable() {
    return this.proceedButton ? !this.deactivateClientForm.valid : false;
  }
}
